import { JsonRpcSigner, StaticJsonRpcProvider } from "@ethersproject/providers";
import { Web3Provider } from "@ethersproject/providers/lib/web3-provider";
import { getProvider } from "lib/rpc";

type ContractFactory<T> = {
  connect: (address: string, provider: JsonRpcSigner | StaticJsonRpcProvider) => T;
};

export const getEthersContract = <T>(
  factory: ContractFactory<T>,
  chainId: number,
  address: string,
  library: Web3Provider | undefined
): T => {
  const provider = getProvider(library, chainId);
  const contract = factory.connect(address, provider);

  return contract;
};
